import { api } from "./api";

export const getEventCalculatorOptions = () =>
  api.get("/api/v1/event_calculator/options");

export const calculateEventCalculator = (payload) =>
  api.post("/api/v1/event_calculator/calculate", payload);
